import { useState } from 'react'
import map from 'lodash-es/map'

import { deleteFileV3 } from '../../../api'
import { EMPTY_LIST } from '../../../constants/common'

// #TODO Should be improved and probably reworked
export function useFileUpload({
  avatar,
  files,
  outboundUuid,
  onDeleteFile = deleteFileV3,
  onSetAvatar,
  onSetFiles,
}) {
  const [filesUploading, setFilesUploading] = useState(EMPTY_LIST)
  const [filesError, setFilesError] = useState(EMPTY_LIST)

  function handleStartUploading(newfiles) {
    setFilesUploading(val => [...val, ...newfiles])
  }

  function handleUploadFile(acceptedFiles) {
    const uploadedIds = map(acceptedFiles, 'name')

    onSetFiles(val => [...val, ...acceptedFiles])
    setFilesUploading(val => val.filter(f => !uploadedIds.includes(f.id)))
  }

  function handleUploadErrors(errors) {
    const uploadedIds = map(errors, 'id')

    setFilesUploading(val => val.filter(f => !uploadedIds.includes(f.id)))
    setFilesError(e => [...e, ...errors])
  }

  function handleRemoveFile(id) {
    if (id === avatar && onSetAvatar) {
      onSetAvatar(null)
    }

    if (files.find(f => f.id === id)) {
      try {
        onDeleteFile(id, { outboundUuid })
      } catch (err) {
        console.error(err)
      }

      onSetFiles(val => val.filter(f => f.id !== id))
    }

    setFilesError(val => val.filter(f => f.id !== id))
    setFilesUploading(val => val.filter(f => f.id !== id))
  }

  function handleExcludeFile(id) {
    onSetFiles(val => val.filter(f => f.id !== id))
    setFilesError(val => val.filter(f => f.id !== id))
  }

  function handleClearFilesUploading() {
    setFilesUploading([])
  }

  return {
    filesError,
    filesUploading,
    handleClearFilesUploading,
    handleExcludeFile,
    handleRemoveFile,
    handleStartUploading,
    handleUploadErrors,
    handleUploadFile,
    totalFilesCount: filesUploading.length + files.length,
  }
}
